var app = angular.module("leonardo");

var UserAccountStates = function($stateProvider) {
  $stateProvider.state('user-manage-account', {
    url: "/user/manage-account",
    parent: 'authenticated.layout-main',
    title: 'My Account',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      },
      'content': { templateUrl: 'views/templates/account-user/form/user-edit.html' }
    },
    ncyBreadcrumb: {
      label: 'Manage My Account'
    }
  });
};

app.config(['$stateProvider', UserAccountStates]);
